import { configureStore } from "@reduxjs/toolkit";

// import cartSlice from './slices/cartSlice'; --demo how to import in slice file in store.js
// import NotInterestedReducer from "./slices/NotInterestedSlice";
// import NotInterestedReducer from "./slices/NotInterestedSlice";
import NotInterestedSlice from "./slices/NotInterestedSlice";

export const store = configureStore({
  reducer: {
    NotInterested: NotInterestedSlice,
    // carts: cartSlice,
  },
});
